const MS_IN_SECOND = 1000
const MS_IN_MINUTE = MS_IN_SECOND * 60
const MS_IN_HOUR = MS_IN_MINUTE * 60
const MS_IN_DAY = MS_IN_HOUR * 24
const MS_IN_MONTH = MS_IN_DAY * 30.4375
const MS_IN_YEAR = MS_IN_DAY * 365

function parseDate(date: Date | string): Date {
  return new Date(date)
}

function getTimeDifferenceUnits(diffTime: number): string {
  const diffYears = Math.floor(diffTime / MS_IN_YEAR)
  if (diffYears > 0) {
    return `${diffYears} ${diffYears === 1 ? 'ano' : 'anos'}`
  }

  const diffMonths = Math.floor(diffTime / MS_IN_MONTH)
  if (diffMonths > 0) {
    return `${diffMonths} ${diffMonths === 1 ? 'mês' : 'meses'}`
  }

  const diffDays = Math.floor(diffTime / MS_IN_DAY)
  if (diffDays > 0) {
    return `${diffDays} ${diffDays === 1 ? 'dia' : 'dias'}`
  }

  const diffHours = Math.floor(diffTime / MS_IN_HOUR)
  if (diffHours > 0) {
    return `${diffHours} ${diffHours === 1 ? 'hora' : 'horas'}`
  }

  const diffMinutes = Math.floor(diffTime / MS_IN_MINUTE)
  if (diffMinutes > 0) {
    return `${diffMinutes} ${diffMinutes === 1 ? 'minuto' : 'minutos'}`
  }

  const diffSeconds = Math.floor(diffTime / MS_IN_SECOND)
  if (diffSeconds === 1) {
    return `${diffSeconds} segundo`
  }
  return `${diffSeconds} segundos`
}

export function timeDiffFromNow(date: Date | string): string {
  const parsedDate = parseDate(date)
  const now = new Date()
  const diffTime = Math.abs(now.getTime() - parsedDate.getTime())
  return getTimeDifferenceUnits(diffTime)
}

export function diffYears(year: string) {
  const currentYear = new Date().getFullYear()
  const parsedYear = parseInt(year)

  if (currentYear === parsedYear) {
    return 'Menos de um ano'
  }

  if (currentYear === parsedYear + 1) {
    const diffYear = currentYear - parsedYear
    return `${diffYear} ano`
  }

  if (currentYear >= parsedYear + 2) {
    const diffYear = currentYear - parsedYear
    return `${diffYear} anos`
  }
}
export function formatDateTime(dateString?: string): string {
  if (!dateString) {
    return ''
  }
  const date = new Date(dateString)

  const day = date.getUTCDate().toString().padStart(2, '0')
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0')
  const year = date.getUTCFullYear()
  const hours = date.getUTCHours().toString().padStart(2, '0')
  const minutes = date.getUTCMinutes().toString().padStart(2, '0')

  const formattedDate = `${day}/${month}/${year} - ${hours}h${minutes}`

  return formattedDate
}

export function getMonth(date: string): string {
  const parsedDate = parseDate(date)
  return new Intl.DateTimeFormat('pt-BR', { month: 'long' }).format(parsedDate)
}

export function getYearFromBack(date: string): number {
  const parsedDate = parseDate(date)
  return parsedDate.getFullYear()
}
